import {api} from "./routes";
import {generatePath} from "react-router";
import {makeRequest, Methods} from "./request";

// METHODS
// ---- GET : Fetch one single LevelA problem based on its identifier
export function get_single_problem(identifier, token) {
    const url = api.domain + generatePath(api.routes.singleProblem, { identifier })
    return makeRequest(url, Methods.GET, null, token)
}

// ---- GET : Fetch given exerciser problem
export function get_exerciser_problem(identifier) {
    const url = api.domain + generatePath(api.routes.exerciserProblem, { identifier })
    return makeRequest(url, Methods.GET, null)
}

// GET : Fetch brevet and published LevelAs
export function get_brevet_levelAs() {
    const url = api.domain + generatePath(api.routes.brevetLevelAs)
    return makeRequest(url, Methods.GET, null)
}

// GET : Fetch single LevelA by id
export function get_single_levelA_by_slug(slug) {
    const url = api.domain + generatePath(api.routes.singleLevelA, { slug })
    return makeRequest(url, Methods.GET, null)
}

// GET : Fetch LevelAs for graph
export function get_levelAs_for_graph() {
    const url = api.domain + generatePath(api.routes.levelAsForGraph)
    return makeRequest(url, Methods.GET, null)
}